<div class="flex my-2.5 mx-7 flex-col flex-1 overflow-hidden">
  <form class="flex flex-col h-full" #CORForm="ngForm" role="form">
    <app-search-input
      (searchText)="onSearch($event)"
      placeholder="Search CORs by name or Number..."
      label=""
    ></app-search-input>

    @if (allCORs().length > 0) {
      <div class="flex items-center gap-6 px-2 min-h-14">
        <app-checkbox
          type="square"
          [name]="'COR_checkbox_all'"
          [ngModel]="selectedCORIds().length === allCORs().length"
          (onChange)="toggleAllCORs($event)"
          [binary]="true"
        ></app-checkbox>
        <div class="text-navy-900 font-bold text-base">COR Title</div>
        <div class="text-navy-900 font-bold ml-auto flex justify-center w-20">Amount</div>
      </div>
      <div class="border-b border-b-solid border-navy-300"></div>
    }

    <app-loading-bar
      class="w-full z-10"
      [ngClass]="{ invisible: !corsLoading() }"
      mode="indeterminate"
    ></app-loading-bar>
    <div appScrolledToBottom (scrolledToBottom)="scrolledToBottom($event)" class="sk-scrollbar overflow-scroll">
      @for (cor of allCORs(); track cor.id) {
        <div class="flex items-center gap-6 my-2 px-2">
          <app-checkbox
            type="square"
            [binary]="false"
            [name]="'COR_checkbox_' + cor.id"
            [value]="cor.id"
            (ngModelChange)="toggleCOR(cor)"
            [ngModel]="selectedCORIds()"
            [inputId]="String(cor.id)"
          ></app-checkbox>
          <app-faded-text [displayGrid]="true">
            <div class="flex max-w-72 flex-col text-navy-900 font-semibold text-sm">
              <span>{{ cor?.number ?? '-' }}</span>
              <span>{{ cor.title }}</span>
            </div>
          </app-faded-text>
          <div
            [class.negative]="cor.total_requested < 0"
            class="ml-auto flex justify-center min-w-20 text-navy-900 font-semibold text-sm text-center"
          >
            {{ cor.total_requested | money: 'positiveComa' }}
          </div>
        </div>
        <div class="border-b border-b-solid border-navy-300"></div>
      } @empty {
        <div class="flex items-center justify-center h-20">
          <span class="font-bold">No available CORs.</span>
        </div>
      }
    </div>
  </form>
</div>
